import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button, Select, Form } from 'Components';
import { NotificationManager } from 'Components/Notifications';
import { Alert } from '@mui/material';


import {
    getRoutesLayerMap,
    importRouteStop,
    openStopImport,
    clearRedux
} from 'Redux/actions';


const ImportRoute = (props) => {
    const dispatch = useDispatch();
    const { callBack, driver } = props;
    const { messages } = useIntl();
    const [error, setError] = useState('');
    const selectOptionForm = useRef();

    const allRoutes = useSelector(state => state.realtimeMapLayerMapModuleRedux.allRoutes);

    const {
        openImport,
        loadingImport,
        responseImport
    } = useSelector((state) => state.RoutesRedux);

    const [route, SetRoute] = useState({});


    useEffect(() => {
        dispatch(getRoutesLayerMap({}))
    }, []);

    useEffect(() => {
        if(!responseImport?.error && responseImport?.imports){
            NotificationManager.success(
                messages['FSM_SETTINGS_ROUTE_IMPORT_DONE'],
                messages['success'],
                3000,
                null,
                null,
                'Success',
            );

            dispatch(clearRedux("FSM_ROUTES_STOP", {
                responseImport: {}
            }));

            SetRoute({});
            callBack();
        }
    }, [responseImport]);

    const selectOption = useCallback(() => {

        if (!route?.id) {
            setError(messages['FSM_SETTINGS_ROUTE_IMPORT_ERROR']);
            return;
        }

        dispatch(importRouteStop({
            routeId: route?.id,
            driverId: driver?.driverId
        }))

    });

    const handleClose = useCallback(() => {
        dispatch(openStopImport(false));
        SetRoute({})
    });

    return (
        <Modal
            title={messages["FSM_SETTINGS_ROUTE_IMPORT_TITLE"]}
            open={openImport}
            position="right"
            size="small"
            handleClose={handleClose}
        >
            <ModalBody>
                <div style={{ padding: '18px 24px 24px 24px' }}>

                    {
                        error &&
                        <Alert severity="error" onClose={() => setError('')}>{error}</Alert>
                    }
                    <Form ref={selectOptionForm} onValidSubmit={selectOption}>

                        <Select
                            id="routes"
                            label={messages['FSM_SETTINGS_ROUTES']}
                            placeholder={messages['FSM_SETTINGS_ROUTES']}
                            value={route}
                            onChange={(event) => {
                                SetRoute(event);
                            }}
                            options={allRoutes?.items}
                            textField="title"
                            valueField="id"
                            required
                        />

                    </Form>
                </div>
            </ModalBody>

            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }} >
                <Button
                    disabled={loadingImport}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loadingImport}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        selectOptionForm.current.submit();
                    }}
                    className="btn-blue"
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default ImportRoute;